import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import './index.css';
import App from './App';

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: 'us-east-2_J4ZHcOA3I',
            userPoolClientId: '3jqprv86effuecmorqor7tob37',
            region: 'us-east-2',
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);